module.exports = __webpack_public_path__ + "img/ufa-bet-support.c75a682d.png";